/**
 * @Author: v_jppjpeng
 * @Date: 2023-3-14 10:26:48
 * @Explain: 业务管理（项目、绑定角色、权限）
 */

export default {
  'BUSINESS.MANAGE.CREATE.TITLE': 'Create a project',
  'BUSINESS.MANAGE.CREATE.TITLE.DESC': 'Fill in your project information',
  'BUSINESS.MANAGE.CREATE.TIPS1':
    'If the project is already registered on Player Network,',
  'BUSINESS.MANAGE.CREATE.TIPS2': ' click here ',
  'BUSINESS.MANAGE.CREATE.TIPS3':
    'enter the project ID to quickly create a project',
  'BUSINESS.MANAGE.CREATE.FORM.NAMEEN': 'English game name',
  'BUSINESS.MANAGE.CREATE.FORM.NAMEZH': 'Chinese game name',
  'BUSINESS.MANAGE.CREATE.FORM.GAME.NAME': 'Game title',
  'BUSINESS.MANAGE.CREATE.FORM.DEVELOPER': 'Developer',
  'BUSINESS.MANAGE.CREATE.FORM.PUBLISHING.METHOD': 'Publishing method',
  'BUSINESS.MANAGE.CREATE.FORM.GAME.CONTACT': 'Game contact person',
  'BUSINESS.MANAGE.CREATE.FORM.REMARKS': 'Remarks',
  'BUSINESS.MANAGE.CREATE.FORM.COMPANY': 'Company/Studio',

  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.NAMEEN': 'Enter the English game name',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.NAMEZH': 'Enter the Chinese game name',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.GAME.NAME': 'Enter game title',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.DEVELOPER': 'Select the developer',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.USERNAME': 'Enter username',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.PUBLISHING.METHOD':
    'Select the publishing method',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.GAME.CONTACT':
    "Enter the game's contact person",
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.REMARKS': 'Insert remarks',
  'BUSINESS.MANAGE.CREATE.PLACEHOLDER.COMPANY': 'Enter company/studio name',

  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS01': 'In-house studio',
  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS02': 'Chinese studio',
  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS03': 'Overseas studio',
  'BUSINESS.MANAGE.CREATE.DEVELOP.OPTIONS04': 'Others',

  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS01': 'Published by IEG Global',
  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS02':
    'Published by authorized external party',
  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS03':
    'IEG domestic publishing line',
  'BUSINESS.MANAGE.CREATE.PUBLISHMODE.OPTIONS04': 'Others',

  'BUSINESS.MANAGE.JOIN.MAIN.TITLE': 'PNT project quick creation',
  'BUSINESS.MANAGE.JOIN.TITLE': 'Join existing project',
  'BUSINESS.MANAGE.JOIN.TITLE.TIPS':
    'For projects that have already been created in SmartLink or Player Network and have been assigned an ID.',
  'BUSINESS.MANAGE.PROJECT.CREATED':
    'Project has been created, contact the owner to join this project',
  'BUSINESS.MANAGE.JOIN.PROJECT.NOEXIST': 'ID does not exist',
  'BUSINESS.MANAGE.JOIN.PROJECT.TOAST.NOEXIST': 'Project ID does not exist',
  'BUSINESS.MANAGE.JOIN.PROJECTID': 'Enter the project ID',
  'BUSINESS.MANAGE.JOIN.PLACEHOLDER1':
    'Enter the project ID that is registered in PNT',
  'BUSINESS.MANAGE.JOIN.PROJECTID.TIPS':
    'You can get the ID from Owner of the project',
  'BUSINESS.MANAGE.JOIN.PLACEHOLDER': 'Enter the project ID here',
  'BUSINESS.MANAGE.JOIN.PROJECTINFO': 'Project Info',
  'BUSINESS.MANAGE.JOIN.PROJECT.ID': 'ID',
  'BUSINESS.MANAGE.JOIN.PROJECT.NAME': 'Name',
  'BUSINESS.MANAGE.JOIN.PROJECT.APLLYROLE': 'Apply for Project Role',
  'BUSINESS.MANAGE.JOIN.PROJECT.OWNER': 'Owner',
  'BUSINESS.MANAGE.JOIN.PROJECT.OWNER.TIPS':
    'The owner is the primary contact for the project and this role can only be assigned to 1 user. The owner has full access to the project and is allowed to invite new users for the Admin, Manager, and Author roles.',
  'BUSINESS.MANAGE.JOIN.PROJECT.ADMIN': 'Admin',
  'BUSINESS.MANAGE.JOIN.PROJECT.ADMIN.TIPS':
    'The admin has access to most functions in the project, they cannot export or delete contacts for example. The admin is allowed to invite new users for the Manager and Author roles.',
  'BUSINESS.MANAGE.JOIN.PROJECT.MANAGER': 'Manager',
  'BUSINESS.MANAGE.JOIN.PROJECT.MANAGER.TIPS':
    'The manager has access to import contacts, create email templates, and create and launch campaigns. The manager cannot invite new users.',
  'BUSINESS.MANAGE.JOIN.PROJECT.AUTHOR': 'Author',
  'BUSINESS.MANAGE.JOIN.PROJECT.AUTHOR.TIPS':
    'The author has access to create, edit, delete email templates and campaigns. The author has no access to launch campaigns.',
  'BUSINESS.MANAGE.JOIN.PROJECT.ROLE.TOAST.NOEXIST': 'Project role required',
  'BUSINESS.MANAGE.JOIN.PROJECT.TOAST.SUCCESS': 'Success!',
  'BUSINESS.MANAGE.JOIN.PROJECT.ALREADY.EXISTS':
    "You're already part of the project. If your permissions need to be adjusted, please contact the owner.",

  'BUSINESS.MANAGE.PERMISSION.TITLE': 'Permission List',

  'BUSINESS.MANAGE.PERMISSION.TABS.MYPERMISSION': 'My Permissions',
  'BUSINESS.MANAGE.PERMISSION.TABS.ALLPERMISSION': 'All Permissions',
  'BUSINESS.MANAGE.PERMISSION.TABS.MYPENDINGAPPROVAL':
    'Pending approval from me',

  'BUSINESS.MANAGE.PERMISSION.PLACEHOLDER.PROJECT': 'Select the project',

  'BUSINESS.MANAGE.PERMISSION.TABLE.PROJECTNAME': 'Project Name',
  'BUSINESS.MANAGE.PERMISSION.TABLE.PROJECTID': 'Project ID',
  'BUSINESS.MANAGE.PERMISSION.TABLE.ROLE': 'Role',
  'BUSINESS.MANAGE.PERMISSION.TABLE.USERNAME': 'Username',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS': 'Status',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPLICANT': 'Applicant',
  'BUSINESS.MANAGE.PERMISSION.TABLE.ACTIVATION.TIME': 'Activation time',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPLICATION.TIME': 'Application time',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVALBY': 'Approver',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVALSTATUS': 'Approval status',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.REMOVE': 'Remove',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.REAPPLY': 'Re-apply',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.AGREE': 'Agree',
  'BUSINESS.MANAGE.PERMISSION.TABLE.BUTTON.REJECT': 'Reject',

  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVAL.DIALOG.AGREE.TITLE':
    'Confirm approval?',
  'BUSINESS.MANAGE.PERMISSION.TABLE.APPROVAL.DIALOG.REJECT.TITLE':
    'Confirm rejection?',
  'BUSINESS.MANAGE.PERMISSION.TABLE.MYPERMISSION.DIALOG.REMOVE.TITLE':
    'Confirm removal?',

  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REMOVE': 'Remove?',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REJECT': 'Reject',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REAPPLY': 'Re-apply',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.AGREE': 'Agree',

  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REMOVE.SUCCESS':
    'removal succeeded!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REMOVE.FAIL': 'removal failed!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REJECT.SUCCESS':
    'rejection succeeded!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.REJECT.FAIL': 'rejection failed!',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPLY.SUCCESS':
    'Application submitted, pending approval',

  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPROVALED.SUCCESS':
    'Approval succeeded',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPLY.SUCCESS.WAIT':
    'Pending approval from Player Network',
  'BUSINESS.MANAGE.PERMISSION.TABLE.OPERATION.APPLY.FAIL':
    'Application submission failed!',

  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.APPLYING': 'Application in progress',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.APPROVALED': 'Passed',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.AVAILABLE': 'Available',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.REJECTED': 'Rejected',
  'BUSINESS.MANAGE.PERMISSION.TABLE.STATUS.RE_APPLYING':
    'Re-application in progress',

  // 我的项目 - 列表
  'BUSINESS.MANAGE.PROJECT.LIST.TITLE': 'Projects list',
  'BUSINESS.MANAGE.PROJECT.LIST.AVAILABLE': 'Available',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING': 'Pending',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.TIPS.TITLE':
    'Explanation of pending approval',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.TIPS1':
    'The SmartLink system administrator will complete the review within 1 business day.',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.TIPS2':
    'If you have any questions, please contact <a href="mailto:{mail}">{mail}</a>',
  'BUSINESS.MANAGE.PROJECT.LIST.PROJECT.INFO': 'Project info',
  'BUSINESS.MANAGE.PROJECT.LIST.MY.ROLE': 'My role',
  'BUSINESS.MANAGE.PROJECT.LIST.JOINING.TIME': 'Joining time',
  'BUSINESS.MANAGE.PROJECT.LIST.APPLICATION.TIME': 'Application time',
  'BUSINESS.MANAGE.PROJECT.LIST.APPLICATION.TIME.TIPS': 'Project creation time',
  'BUSINESS.MANAGE.PROJECT.LIST.APPLICATION.STATUS': 'Application status',
  'BUSINESS.MANAGE.PROJECT.LIST.PASSED': 'Passed',
  'BUSINESS.MANAGE.PROJECT.LIST.REJECTED': 'Rejected',
  'BUSINESS.MANAGE.PROJECT.LIST.PENDING.APPROVAL': 'Pending approval',
  'BUSINESS.MANAGE.PROJECT.LIST.REAPPLY': 'Reapply',
  'BUSINESS.MANAGE.PROJECT.LIST.INVITER': 'Inviter',
  'BUSINESS.MANAGE.PROJECT.LIST.YOURSELF': 'Yourself',
  'BUSINESS.MANAGE.PROJECT.LIST.CURRENT': 'Current',
  'BUSINESS.MANAGE.PROJECT.LIST.CURRENT.TIPS': 'Currently selected project',
  'BUSINESS.MANAGE.PROJECT.LIST.ENTER': 'Enter',
  'BUSINESS.MANAGE.PROJECT.DEMO': 'Demo project',
};
